<template>
	<div class="address-list">
		<el-row :gutter="20">
			<el-col :span="6" class="el-col">
				<div class="add-box flex-row flex-center" @click="addCreditCard">
					<div class="add-icon"> <i class="el-icon-circle-plus"></i></div>
					<div>{{ $t('trade.CreditCardList.767829-0') }}</div>
				</div>
			</el-col>
			<el-col :span="6" v-for="(item,index) in creditCardList" :key="item.addressId" class="el-col">
				<credit-card-detail :cardinfo='item' :selectinfo='selectedCardInfo' @edit='editCreditCard' @remove='removeCreditCard' @selectCard='selectCreditCard'></credit-card-detail>
			</el-col>
		</el-row>

		<!-- <address-edit  v-if="showEditDialog" :isFromTradeConfirmWithBondGoods='isFromTradeConfirmWithBondGoods' :addressinfo="currentAddr" :title="dialogTitle" :isCreate="createEditDialog"
			:isShow="showEditDialog" @close="closeEditDialog" @success="editSuccess"></address-edit> -->

		<el-dialog :title="dialogTitle" :visible.sync="showEditDialog" v-if="showEditDialog" :destroy-on-close='true' :before-close="onClose" :close-on-click-modal="false" center width="430px" :append-to-body="true">
			<el-form :model="editCardInfo" @submit.native.prevent>
				<el-form-item>
					<el-select style="width: 100%;" v-model="editCardInfo.belongBankName" :placeholder="$t('trade.CreditCardList.767829-2')" filterable>
						<el-option v-for="item in bankList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="editCardInfo.accountName" autocomplete="off" :placeholder="$t('trade.CreditCardList.767829-3')" maxlength="64"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="editCardInfo.accountNumber" autocomplete="off" :placeholder="$t('trade.CreditCardList.767829-4')" maxlength="50"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="editCardInfo.openingBank" autocomplete="off" :placeholder="$t('trade.CreditCardList.767829-5')" maxlength="100"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onClose">{{ $t('common.action.cancel') }}</el-button>
				<el-button type="danger" @click="saveCard">{{ $t('trade.AddressEdit.721046-25') }}</el-button>
			</div>
		</el-dialog>

	</div>

</template>

<script>
	import creditCardDetail from './CreditCardDetail.vue'
	import {
		getCustomerBankListFromCrm,
		editCustomerBankInfo,
		deleteCustomerBankInfo,
		addCustomerBankInfo,
	} from '../../utils/api-utils/api-customer.js'
	import {
		getBanklistOfBigAmountPay
	} from '../../utils/api-utils/api-pay.js'
	export default {
		name: "creditcard-list",
		components: {
			creditCardDetail,
		},
		data() {
			return {
				dialogTitle: '',
				showEditDialog: false,
				selectedCardInfo: {},
				editCardInfo: {},
				bankOptionList: [
					'招商银行',
					'工商银行',
					'建设银行',
					'中信银行',
					'浦发银行',
					'江苏银行',
					'中国银行',
					'中国农业银行',
					'交通银行',
					'中国民生银行',
					'华夏银行',
					'中国邮政储蓄银行',
					'东莞农村农业银行',
					'浙江泰隆商业银行',
					'广发银行',
					'北京银行',
					'平安银行',
					'南京银行',
				],
				creditCardList: [],
			}
		},

		created() {
			// 获取客户的银行卡信息
			this.getCreditCardList()
		},
		methods: {
			/**
			 * 获取客户的银行卡信息
			 */
			async getCreditCardList() {
				// 获取crm收款账户信息
				let creditCardList = await getCustomerBankListFromCrm()

				// 银行卡数据
				let bankList = await getBanklistOfBigAmountPay()

				// 数据过滤
				creditCardList = creditCardList.filter(item => item.accountType == 2)

				// 默认选中第一张可选银行卡 
				creditCardList[0] && (creditCardList[0].isSelected = true);

				this.creditCardList = creditCardList;
				this.selectedCardInfo = creditCardList[0];
				this.bankList = bankList.map(item => {
					return {
						label: item,
						value: item
					}
				})
			},

			/**
			 * 获取客户的银行卡信息
			 */
			addCreditCard() {
				this.dialogTitle = this.$t('trade.CreditCardList.767829-0');
				this.showEditDialog = true;
				this.isEditCard = false;
				this.editCardInfo = {}
			},

			/**
			 * 修改客户的银行卡信息
			 */
			editCreditCard(cardInfo) {
				this.dialogTitle = this.$t('trade.CreditCardList.767829-1');
				this.showEditDialog = true;
				this.isEditCard = true;
				this.editCardInfo = cardInfo ? JSON.parse(JSON.stringify(cardInfo)) : {}
			},

			/**
			 * 保存银行卡 修改
			 */
			async saveCard() {
				// 必填校验
				if (!this.editCardInfo.belongBankName) {
					return this.$message.error(this.$t('trade.CreditCardList.767829-2'));
				}
				if (!this.editCardInfo.accountName) {
					return this.$message.error(this.$t('trade.CreditCardList.767829-8'));
				}
				if (!this.editCardInfo.accountNumber) {
					return this.$message.error(this.$t('trade.CreditCardList.767829-9'));
				}
				if (!this.editCardInfo.openingBank) {
					return this.$message.error(this.$t('trade.CreditCardList.767829-10'));
				}

				let saveIndex = this.isEditCard ? this.creditCardList.findIndex(item => item.id == this.editCardInfo.id) : this.creditCardList.length;

				// 增加参数
				this.editCardInfo.accountType = 2;

				// 新增/修改 接口
				let newData = this.isEditCard ? await editCustomerBankInfo(this.editCardInfo) : await addCustomerBankInfo(this.editCardInfo);

				if (!newData || !newData.id) {
					return this.$message.error(this.$t('trade.CreditCardList.767829-11'));
				}

				// 更新数据
				this.editCardInfo.id = newData.id;

				// 如果编辑的是当前选择数据 需要同步更新
				this.selectedCardInfo = this.isEditCard && this.editCardInfo.id == this.selectedCardInfo.id ? this.editCardInfo : this.selectedCardInfo;

				this.creditCardList[saveIndex] = this.editCardInfo;
				this.showEditDialog = false;
			},

			/**
			 * 选中银行卡
			 */
			selectCreditCard(cardInfo) {
				this.selectedCardInfo = this.creditCardList.find(item => item.id == cardInfo.id)
			},

			/**
			 * 删除客户的银行卡信息
			 */
			removeCreditCard(cardInfo) {
				this.$confirm(this.$t('trade.CreditCardList.767829-12'), {
					confirmButtonText: this.$t('common.action.confirm'),
					cancelButtonText: this.$t('common.action.cancel')
				}).then(() => {
					deleteCustomerBankInfo(cardInfo);

					// 是否删除的是 选中的数据
					let isDeleteSelectedCard = cardInfo.id == this.selectedCardInfo.id;

					// 列表数据删除
					this.creditCardList = this.creditCardList.filter(item => cardInfo.id != item.id)

					this.selectedCardInfo = isDeleteSelectedCard ? this.creditCardList[0] : this.selectedCardInfo
				});
			},

			onClose() {
				// 清空数据
				this.selectedCardInfo = {};
				this.showEditDialog = false;
			},


		}
	}
</script>

<style scoped="scoped">
	.address-list {
		max-height: 400px;
		overflow: hidden;
		overflow-y: scroll;
	}

	.address-list::-webkit-scrollbar {
		display: none;
	}

	.add-box {
		height: 110px;
		color: #999;
		margin-bottom: 20px;
		font-size: 18px;
		border: 1px solid #dedede;
		cursor: pointer;
	}

	.add-icon {
		font-size: 30px;
		margin-right: 15px;
	}
</style>